/*
 * Fullwidth Carousel
 *   - Crossfade between slides (CSS handles the opacity transition)
 *   - Dot indicators with click-to-go
 *   - Optional autoplay (data-autoplay="1") with 5s interval; pauses while
 *     the user's pointer is on the carousel and on tab visibility loss.
 */

const AUTOPLAY_MS = 5000;

function initOne(root) {
    if (root.dataset.wired === '1') return;
    root.dataset.wired = '1';

    const slides = Array.from(root.querySelectorAll('.fullwidth-carousel__slide'));
    const dots   = Array.from(root.querySelectorAll('.fullwidth-carousel__dot'));
    if (slides.length < 2) return;

    let index    = slides.findIndex((s) => s.classList.contains('is-active'));
    if (index < 0) index = 0;
    let timer    = 0;
    const autoplay = root.dataset.autoplay === '1';

    const goTo = (i) => {
        index = (i + slides.length) % slides.length;
        slides.forEach((s, n) => s.classList.toggle('is-active', n === index));
        dots.forEach((d, n)   => d.classList.toggle('is-active', n === index));
    };

    const advance = () => goTo(index + 1);

    const start = () => {
        if (!autoplay) return;
        stop();
        timer = window.setInterval(advance, AUTOPLAY_MS);
    };
    const stop = () => {
        if (timer) { window.clearInterval(timer); timer = 0; }
    };

    dots.forEach((dot) => {
        dot.addEventListener('click', () => {
            const i = parseInt(dot.dataset.index, 10) || 0;
            goTo(i);
            start(); // reset the autoplay timer after manual nav
        });
    });

    // Pause on hover so the user can study a slide; resume on leave.
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    // Pause when the tab is hidden so we don't burn cycles in the background.
    document.addEventListener('visibilitychange', () => {
        if (document.hidden) stop(); else start();
    });

    start();
}

export function initFullwidthCarousels() {
    document.querySelectorAll('.js-fullwidth-carousel').forEach(initOne);
}
